import { Info } from "@phosphor-icons/react"
import { Skeleton } from "../reusable/Skeleton"

export const StatusTabLoading = () => <Skeleton className="h-[300px]" />

export const StatusTabEmpty = ({
  message,
  icon: IconComp = Info,
}: {
  message: string
  icon?: typeof Info
}) => (
  <div className="flex min-h-[240px] flex-col items-center justify-center gap-2 text-fg-subtle">
    <IconComp size={28} className="text-fg-disabled" />
    <span className="label-base">{message}</span>
  </div>
)
